import React from 'react';
import { styled } from '@mui/material/styles';
import { Paper, TableRow, TableHead, TableContainer, TableBody, Table } from '@mui/material';
import { StyledTableCell } from 'components/Common/MUIStyledComponents';

const PREFIX = 'SearchedProps';

const classes = {
  table: `${PREFIX}-table`,
  paper: `${PREFIX}-paper`
};

const StyledTableContainer = styled(TableContainer)({
  [`& .${classes.table}`]: {
    backgroundColor: '#2E3036',
    width: '110%',
    borderRadius: '8px'
  },
  [`&.${classes.paper}`]: {
    height: '415px',
    paddingRight: '17px',
    boxSizing: 'content-box',
    width: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',

  }
});

interface ISearchedPropsProps {
  rowData: any[],
}

const SearchedProps: React.FC<ISearchedPropsProps> = (props: ISearchedPropsProps) => {
  const { rowData, } = props;


  return (
    <StyledTableContainer component={Paper} className={classes.paper}>
      <Table className={classes.table} aria-label='customized table'>
        <TableHead>
          <TableRow>
            <StyledTableCell>
              <div className='props-header-div'>
                <p className='props-header-text'>Data Field</p>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                  <path d='M7.99967 3.33398V12.6673M7.99967 12.6673L12.6663 8.00065M7.99967 12.6673L3.33301 8.00065' stroke='#F5FAFF' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <p className='props-header-text'>Property</p>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData.map((row: any, i: number) => (
            <TableRow key={i}>
              <StyledTableCell>{row.val}</StyledTableCell>
              <StyledTableCell>{row.prop}</StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default SearchedProps;
